import * as Yup from 'common/yup';
import {passphrase} from 'common/yup/customs/passphrase';
import {SSHKeyPairTypeSchema, SSHKeyPairType} from 'types/diplomat/enums/KeyPairType';
import {enums} from 'types/enums';

export const createSSHKeyPairSchema = Yup.object({
   keyName: Yup.string().required(),
   keyType: SSHKeyPairTypeSchema.default(SSHKeyPairType.enum.RSA),
   bitStrength: Yup.number().default(2048),
   eccurveType: Yup.originString()
      .oneOf(enums.eccurveTypeCreatable.keys)
      .default(enums.eccurveType.enum.NISTP521),
   passPhrase: passphrase().required(),
   existingPassphrase: Yup.string().oneOf(
      [Yup.ref('passPhrase'), null],
      'Passphrase entries do not match'
   ),
   overwrite: Yup.boolean().default(false),
   folderId: Yup.idString(),
});

export type CreateSSHKeyPair = Yup.InferType<typeof createSSHKeyPairSchema>;
